import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const items = ['The full 21 day protocol, day by day', 'The 4 Lock Sequence explained clearly', 'Sleep reset minimums that are easy to follow', 'Two anchor meals you can repeat without thinking', 'A three day strength plan you can do with dumbbells or in a gym', 'Bloat trigger checklist and rotation plan', 'Troubleshooting guide for stalls, cravings, travel, and stress weeks', 'Printable trackers so you can see progress without obsessing'];
export function WhatsInsideSection() {
  return <section className="w-full px-6 py-20 md:py-28 bg-white border-t border-cream-200" data-id="element-152">
      <div className="max-w-6xl mx-auto" data-id="element-153">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-154">
          <h2 className="font-serif text-3xl md:text-4xl text-stone-800" data-id="element-155">
            What is inside
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-156">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-157">
            <img src="https://cdn.magicpatterns.com/uploads/gnUDfcn1Brw8kVEQFv5pr9/N1PIC1.png" alt="The 21 Day Perimenopause Belly Reset digital product" className="w-full rounded-lg shadow-xl" data-id="element-158" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-159">
            <ul className="space-y-4" data-id="element-160">
              {items.map((item, index) => <li key={index} className="flex items-start" data-id="element-161">
                  <Check className="w-5 h-5 text-terracotta mt-1 mr-3 flex-shrink-0" data-id="element-162" />
                  <span className="text-lg text-stone-600" data-id="element-163">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}